<template>
  <div id="ReimbursementMgmt" class="purchase-mgmt-page">
    <div class="page-header">
      <div class="filter-card">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">店铺</span>
            <el-select v-model="params.shopName" size="small" filterable clearable placeholder="全部">
              <el-option v-for="item in shopOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">发起人</span>
            <el-select v-model="params.createUserName" size="small" filterable clearable placeholder="全部">
              <el-option v-for="user in createUserOptions" :key="user.id" :label="user.name" :value="user.name"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">业务类型</span>
            <el-select v-model="params.businessTypeId" size="small" filterable clearable placeholder="全部" class="filter-select-wide">
              <el-option v-for="item in businessTypeList" :key="item.businessTypeId" :label="item.name" :value="item.businessTypeId"></el-option>
            </el-select>
            <el-button type="text" size="small" @click="openBusinessTypeDialog">维护</el-button>
          </div>
          <div class="filter-item">
            <span class="filter-label">业务发生日期</span>
            <el-date-picker
              v-model="businessOccurDateRange"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              class="filter-date"
            ></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">发起日期</span>
            <el-date-picker
              v-model="createDateRange"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              class="filter-date"
            ></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">付款时间</span>
            <el-date-picker
              v-model="paymentTimeRange"
              size="small"
              type="datetimerange"
              format="yyyy-MM-dd HH"
              value-format="yyyy-MM-dd HH"
              popper-class="reimbursement-payment-time-popper"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              class="filter-payment-time"
            ></el-date-picker>
          </div>
          <div class="filter-item">
            <el-button type="primary" size="small" icon="el-icon-search" @click="queryBtn">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-plus" @click="openAddDialog">新增报销</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <el-tabs v-model="activeStatusTab" class="status-tabs" @tab-click="onStatusTabChange">
        <el-tab-pane v-for="tab in statusTabs" :key="tab.name" :name="tab.name">
          <span slot="label" class="status-tab-label">
            {{ tab.label }}
            <el-badge v-if="tab.showBadge && statusCounts[tab.name] > 0" :value="statusCounts[tab.name]" class="status-tab-badge"></el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>

      <div class="table-container">
        <el-table
          ref="reimbursementTable"
          :data="tableData"
          border
          stripe
          size="mini"
          :height="screenHeight"
          v-loading="loading"
          element-loading-text="加载中..."
          show-summary
          :summary-method="getTableSummaries"
          header-cell-class-name="table-header-cell"
          class="mgmt-table reimbursement-table"
        >
          <el-table-column label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">{{ params.beginIndex + scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="shopName" label="店铺" width="70" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.shopName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="businessTypeName" label="业务类型" width="100" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.businessTypeName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100" align="center"></el-table-column>
          <el-table-column prop="contentDescription" label="报销内容说明" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.contentDescription || "-" }}</template>
          </el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="90" align="right">
            <template slot-scope="scope">{{ formatAmount(scope.row.unitPrice) }}</template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量" width="70" align="right">
            <template slot-scope="scope">{{ formatQuantity(scope.row.quantity) }}</template>
          </el-table-column>
          <el-table-column prop="totalPrice" label="总价" width="90" align="right">
            <template slot-scope="scope">{{ formatAmount(scope.row.totalPrice) }}</template>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率" width="70" align="right">
            <template slot-scope="scope">{{ formatTaxRate(scope.row.taxRate) }}</template>
          </el-table-column>
          <el-table-column prop="taxAmount" label="税额" width="90" align="right">
            <template slot-scope="scope">{{ formatAmount(scope.row.taxAmount) }}</template>
          </el-table-column>
          <el-table-column prop="shippingFee" label="运费" width="80" align="right">
            <template slot-scope="scope">{{ formatAmount(scope.row.shippingFee) }}</template>
          </el-table-column>
          <el-table-column prop="platformDiscount" label="平台优惠" width="90" align="right">
            <template slot-scope="scope">{{ formatAmount(scope.row.platformDiscount) }}</template>
          </el-table-column>
          <el-table-column label="业务证明图片" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="getFileItems(scope.row.businessProofImages).length" class="proof-thumb-list">
                <template v-for="(item, index) in getFileItems(scope.row.businessProofImages)">
                  <el-image
                    v-if="item.isImage"
                    :key="'proof-img-' + item.url + '-' + index"
                    :src="item.url"
                    :preview-src-list="getImageList(scope.row.businessProofImages)"
                    fit="cover"
                    class="proof-thumb"
                  ></el-image>
                  <a v-else :key="'proof-file-' + item.url + '-' + index" :href="item.url" target="_blank" class="invoice-pdf-link" title="查看文件">
                    <i class="el-icon-document"></i>
                  </a>
                </template>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column label="支付证明" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="getImageList(scope.row.paymentProofImages).length" class="proof-thumb-list">
                <el-image
                  v-for="(url, index) in getImageList(scope.row.paymentProofImages)"
                  :key="url + '-' + index"
                  :src="url"
                  :preview-src-list="getImageList(scope.row.paymentProofImages)"
                  fit="cover"
                  class="proof-thumb"
                ></el-image>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column label="发票" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="getFileItems(scope.row.invoiceFiles).length" class="proof-thumb-list">
                <template v-for="(item, index) in getFileItems(scope.row.invoiceFiles)">
                  <el-image
                    v-if="item.isImage"
                    :key="'img-' + item.url + '-' + index"
                    :src="item.url"
                    :preview-src-list="getImageList(scope.row.invoiceFiles)"
                    fit="cover"
                    class="proof-thumb"
                  ></el-image>
                  <a v-else :key="'pdf-' + item.url + '-' + index" :href="item.url" target="_blank" class="invoice-pdf-link" title="查看 PDF">
                    <i class="el-icon-document"></i>
                  </a>
                </template>
              </div>
              <span v-else class="proof-empty">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="发起人" width="90" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.createUserName || "-" }}</template>
          </el-table-column>
          <el-table-column prop="businessOccurDate" label="业务发生日期" width="120" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.businessOccurDate || "-" }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="发起时间" width="140" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ formatCreateTime(scope.row.createTime) }}</template>
          </el-table-column>
          <el-table-column prop="paymentTime" label="付款时间" width="140" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ formatCreateTime(scope.row.paymentTime) }}</template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{ scope.row.remark || "-" }}</div>
              <div v-if="scope.row.rejectRemark" class="reject-remark">打回：{{ scope.row.rejectRemark }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center" fixed="right" class-name="action-col">
            <template slot-scope="scope">
              <div class="action-cell action-cell-nowrap">
                <el-button
                  v-if="getPrimaryAction(scope.row)"
                  type="text"
                  size="small"
                  class="success"
                  @click="onPrimaryAction(scope.row)"
                >{{ getPrimaryAction(scope.row).label }}</el-button>
                <el-button
                  v-if="canUploadPaymentProof(scope.row)"
                  type="text"
                  size="small"
                  @click="openPaymentProofUpload(scope.row)"
                >{{ getPaymentProofButtonLabel(scope.row) }}</el-button>
                <el-button
                  v-if="canUploadInvoice(scope.row)"
                  type="text"
                  size="small"
                  @click="openInvoiceUpload(scope.row)"
                >{{ getInvoiceButtonLabel(scope.row) }}</el-button>
                <el-dropdown v-if="getMoreActions(scope.row).length" trigger="click" @command="cmd => handleMoreAction(cmd, scope.row)">
                  <el-button type="text" size="small">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                  <el-dropdown-menu slot="dropdown" class="reimbursement-action-dropdown">
                    <el-dropdown-item v-for="action in getMoreActions(scope.row)" :key="action.key" :command="action.key" :class="action.btnClass">
                      {{ action.label }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          layout="prev, pager, next"
          background
          prev-text="上一页"
          next-text="下一页"
          :current-page.sync="currentPage"
          :page-size="params.pageSize"
          :total="total"
          @current-change="onPageChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="addDialogTitle"
      :visible.sync="addDialogVisible"
      width="760px"
      custom-class="reimbursement-add-dialog"
      :close-on-click-modal="false"
      @opened="onAddDialogOpened"
      @closed="onAddDialogClosed"
    >
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="110px" size="small">
        <el-form-item label="店铺" prop="shopName">
          <el-select v-model="addForm.shopName" filterable placeholder="请选择店铺" style="width: 100%">
            <el-option v-for="item in shopOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型" prop="businessTypeId">
          <el-select v-model="addForm.businessTypeId" filterable placeholder="请选择业务类型" style="width: 100%">
            <el-option v-for="item in businessTypeList" :key="item.businessTypeId" :label="item.name" :value="item.businessTypeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务发生日期" prop="businessOccurDate">
          <el-date-picker v-model="addForm.businessOccurDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择业务发生日期" style="width: 220px"></el-date-picker>
        </el-form-item>
        <el-form-item label="报销内容说明" prop="contentDescription">
          <el-input v-model="addForm.contentDescription" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="请输入报销内容说明"></el-input>
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="单价" prop="unitPrice">
              <el-input-number v-model="addForm.unitPrice" :min="0" :precision="2" :controls="false" style="width: 100%" @change="recalcAmounts"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数量" prop="quantity">
              <el-input-number v-model="addForm.quantity" :min="0.01" :precision="2" :controls="false" style="width: 100%" @change="recalcAmounts"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总价">
              <el-input :value="formatAmount(addForm.totalPrice)" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="税率(%)" prop="taxRatePercent">
              <el-input-number v-model="addForm.taxRatePercent" :min="0" :max="100" :precision="2" :controls="false" style="width: 100%" @change="recalcAmounts"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="税额">
              <el-input :value="formatAmount(addForm.taxAmount)" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运费" prop="shippingFee">
              <el-input-number v-model="addForm.shippingFee" :min="0" :precision="2" :controls="false" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="平台优惠" prop="platformDiscount">
              <el-input-number v-model="addForm.platformDiscount" :min="0" :precision="2" :controls="false" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="业务证明图片">
          <div
            ref="proofPastePanel"
            class="proof-upload-panel"
            :class="{ 'is-active': activeUploadTarget === 'proof' }"
            tabindex="0"
            v-loading="proofUploading"
            @click="setActiveUploadTarget('proof')"
            @focus="setActiveUploadTarget('proof')"
          >
            <div class="proof-upload-list">
              <div v-for="(item, index) in businessProofFileItems" :key="item.url + '-' + index" class="proof-upload-item">
                <el-image v-if="item.isImage" :src="item.url" fit="cover" class="proof-upload-image" :preview-src-list="businessProofImageUrls"></el-image>
                <div v-else class="proof-upload-pdf">
                  <a :href="item.url" target="_blank" class="invoice-pdf-link">
                    <i class="el-icon-document"></i>
                    <span>{{ item.name || "文件" }}</span>
                  </a>
                </div>
                <i class="el-icon-error proof-upload-remove" @click.stop="removeProofFile(index)"></i>
              </div>
              <el-upload
                class="proof-upload-add"
                action="/biz/oss/upload"
                name="file"
                accept=".jpg,.jpeg,.png,.gif,.webp,.bmp,.pdf,image/*,application/pdf"
                multiple
                :data="{ bizModule: 'reimbursementMgmt' }"
                :show-file-list="false"
                :before-upload="beforeProofFileUpload"
                :on-success="handleProofUploadSuccess"
                :on-error="handleProofUploadError"
                :disabled="proofUploading"
              >
                <div class="proof-upload-trigger">
                  <i class="el-icon-plus"></i>
                  <span class="proof-upload-text">添加文件</span>
                </div>
              </el-upload>
            </div>
            <div class="proof-upload-tip">支持图片与 PDF；可多选；点击本区域后可 Ctrl+V 粘贴截图</div>
          </div>
        </el-form-item>
        <el-form-item label="发票">
          <div
            ref="invoicePastePanel"
            class="proof-upload-panel"
            :class="{ 'is-active': activeUploadTarget === 'invoice' }"
            tabindex="0"
            v-loading="invoiceUploading"
            @click="setActiveUploadTarget('invoice')"
            @focus="setActiveUploadTarget('invoice')"
          >
            <div class="proof-upload-list">
              <div v-for="(item, index) in invoiceFileItems" :key="item.url + '-' + index" class="proof-upload-item">
                <el-image v-if="item.isImage" :src="item.url" fit="cover" class="proof-upload-image" :preview-src-list="invoiceImageUrls"></el-image>
                <div v-else class="proof-upload-pdf">
                  <a :href="item.url" target="_blank" class="invoice-pdf-link">
                    <i class="el-icon-document"></i>
                    <span>{{ item.name || "PDF" }}</span>
                  </a>
                </div>
                <i class="el-icon-error proof-upload-remove" @click.stop="removeInvoiceFile(index)"></i>
              </div>
              <el-upload
                class="proof-upload-add"
                action="/biz/oss/upload"
                name="file"
                accept=".jpg,.jpeg,.png,.gif,.webp,.bmp,.pdf,image/*,application/pdf"
                multiple
                :data="{ bizModule: 'reimbursementMgmt' }"
                :show-file-list="false"
                :before-upload="beforeInvoiceFileUpload"
                :on-success="handleInvoiceUploadSuccess"
                :on-error="handleInvoiceUploadError"
                :disabled="invoiceUploading"
              >
                <div class="proof-upload-trigger">
                  <i class="el-icon-plus"></i>
                  <span class="proof-upload-text">添加文件</span>
                </div>
              </el-upload>
            </div>
            <div class="proof-upload-tip">支持图片与 PDF；可多选；点击本区域后可 Ctrl+V 粘贴截图</div>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="选填"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addSaving" @click="submitAdd">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="paymentProofUploadTitle"
      :visible.sync="paymentProofUploadVisible"
      width="640px"
      custom-class="reimbursement-payment-proof-dialog"
      :close-on-click-modal="false"
      @opened="onPaymentProofUploadOpened"
      @closed="onPaymentProofUploadClosed"
    >
      <div ref="paymentProofPastePanel" class="proof-upload-panel" tabindex="0" v-loading="paymentProofUploading">
        <div class="proof-upload-list">
          <div v-for="(url, index) in paymentProofUploadUrls" :key="url + '-' + index" class="proof-upload-item">
            <el-image :src="url" fit="cover" class="proof-upload-image" :preview-src-list="paymentProofUploadUrls"></el-image>
            <i class="el-icon-error proof-upload-remove" @click="paymentProofUploadUrls.splice(index, 1)"></i>
          </div>
          <el-upload
            class="proof-upload-add"
            action="/biz/oss/upload"
            name="file"
            accept="image/*"
            multiple
            :data="{ bizModule: 'reimbursementMgmt' }"
            :show-file-list="false"
            :before-upload="beforePaymentProofUpload"
            :on-success="handlePaymentProofUploadSuccess"
            :on-error="handlePaymentProofUploadError"
            :disabled="paymentProofUploading"
          >
            <div class="proof-upload-trigger">
              <i class="el-icon-plus"></i>
              <span class="proof-upload-text">添加图片</span>
            </div>
          </el-upload>
        </div>
        <div class="proof-upload-tip">支持 JPG、PNG、GIF、WEBP、BMP；可上传多张，可在本弹窗内 Ctrl+V 粘贴截图</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="paymentProofUploadVisible = false">取 消</el-button>
        <el-button type="primary" :loading="paymentProofUploadSaving" @click="savePaymentProofUpload">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="invoiceUploadTitle"
      :visible.sync="invoiceUploadVisible"
      width="640px"
      custom-class="reimbursement-invoice-upload-dialog"
      :close-on-click-modal="false"
      @opened="onInvoiceUploadOpened"
      @closed="onInvoiceUploadClosed"
    >
      <div ref="invoiceUploadPastePanel" class="proof-upload-panel" tabindex="0" v-loading="invoiceUploading">
        <div class="proof-upload-list">
          <div v-for="(item, index) in invoiceFileItems" :key="item.url + '-' + index" class="proof-upload-item">
            <el-image v-if="item.isImage" :src="item.url" fit="cover" class="proof-upload-image" :preview-src-list="invoiceImageUrls"></el-image>
            <div v-else class="proof-upload-pdf">
              <a :href="item.url" target="_blank" class="invoice-pdf-link">
                <i class="el-icon-document"></i>
                <span>{{ item.name || "PDF" }}</span>
              </a>
            </div>
            <i class="el-icon-error proof-upload-remove" @click.stop="removeInvoiceFile(index)"></i>
          </div>
          <el-upload
            class="proof-upload-add"
            action="/biz/oss/upload"
            name="file"
            accept=".jpg,.jpeg,.png,.gif,.webp,.bmp,.pdf,image/*,application/pdf"
            multiple
            :data="{ bizModule: 'reimbursementMgmt' }"
            :show-file-list="false"
            :before-upload="beforeInvoiceFileUpload"
            :on-success="handleInvoiceUploadSuccess"
            :on-error="handleInvoiceUploadError"
            :disabled="invoiceUploading"
          >
            <div class="proof-upload-trigger">
              <i class="el-icon-plus"></i>
              <span class="proof-upload-text">添加文件</span>
            </div>
          </el-upload>
        </div>
        <div class="proof-upload-tip">支持图片与 PDF；可多选；可在本弹窗内 Ctrl+V 粘贴截图</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invoiceUploadVisible = false">取 消</el-button>
        <el-button type="primary" :loading="invoiceUploadSaving" @click="saveInvoiceUpload">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="打回报销单" :visible.sync="rejectVisible" width="480px" :close-on-click-modal="false">
      <div class="reject-dialog-tip">确认打回到「{{ rejectTargetStatus || "-" }}」</div>
      <el-form label-width="80px" size="small">
        <el-form-item label="打回原因" required>
          <el-input v-model="rejectRemark" type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请填写打回原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectVisible = false">取 消</el-button>
        <el-button type="primary" :loading="rejectSaving" @click="confirmReject">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="业务类型维护" :visible.sync="businessTypeDialogVisible" width="520px" :close-on-click-modal="false">
      <div class="business-type-toolbar">
        <el-input v-model="newBusinessTypeName" size="small" placeholder="请输入业务类型名称" clearable class="business-type-input"></el-input>
        <el-button type="primary" size="small" :loading="businessTypeSaving" @click="addBusinessType">新增</el-button>
      </div>
      <el-table :data="businessTypeList" border stripe size="mini" max-height="320" v-loading="businessTypeLoading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="name" label="业务类型" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" class="danger" @click="deleteBusinessType(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="businessTypeDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="opreateLogVisible" width="1080px">
      <el-table :data="operateHistory" border stripe size="mini" max-height="420" v-loading="opreateLogLoading">
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateUserName" label="操作人" width="90"></el-table-column>
        <el-table-column prop="opreateTimeLabel" label="操作时间" width="170"></el-table-column>
        <el-table-column prop="opreateTypeLabel" label="操作类型" width="120"></el-table-column>
        <el-table-column prop="fromStatus" label="原状态" width="110" align="center">
          <template slot-scope="scope">{{ scope.row.fromStatus || "-" }}</template>
        </el-table-column>
        <el-table-column prop="toStatus" label="新状态" width="110" align="center">
          <template slot-scope="scope">{{ scope.row.toStatus || "-" }}</template>
        </el-table-column>
        <el-table-column prop="content" label="操作说明" min-width="240" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reimbursementModules, requestModules, ossModules, systemModules } from "@r";
import {
  REIMBURSEMENT_STATUS,
  REIMBURSEMENT_STATUS_TABS,
  REIMBURSEMENT_STATUS_LIST,
  REIMBURSEMENT_VOIDABLE_STATUSES,
  REIMBURSEMENT_REJECTABLE_STATUSES,
  REIMBURSEMENT_EDITABLE_STATUSES,
  REIMBURSEMENT_ACTION_REJECT,
  REIMBURSEMENT_PRIMARY_ACTION,
} from "../../constants/reimbursementStatus.js";

function buildEmptyStatusCounts() {
  const counts = {};
  REIMBURSEMENT_STATUS_LIST.forEach(status => {
    counts[status] = 0;
  });
  return counts;
}

function roundMoney(value) {
  return parseFloat(Number(value || 0).toFixed(2));
}

const SHOP_OPTIONS = ["灵柚", "萧发", "甄昂", "誉腾", "众联"];

function createEmptyAddForm() {
  return {
    shopName: "",
    businessTypeId: "",
    businessOccurDate: "",
    contentDescription: "",
    unitPrice: 0,
    quantity: 1,
    totalPrice: 0,
    taxRatePercent: 0,
    taxAmount: 0,
    shippingFee: 0,
    platformDiscount: 0,
    businessProofImages: [],
    remark: "",
  };
}

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      screenHeight: document.body.clientHeight - 64 - 120 - 100,
      activeStatusTab: REIMBURSEMENT_STATUS_TABS[0].name,
      statusTabs: REIMBURSEMENT_STATUS_TABS,
      statusCounts: buildEmptyStatusCounts(),
      businessTypeList: [],
      createUserOptions: [],
      summary: {
        quantity: 0,
        totalPrice: 0,
        taxAmount: 0,
        shippingFee: 0,
        platformDiscount: 0,
      },
      params: {
        shopName: "",
        createUserName: "",
        businessTypeId: "",
        beginIndex: 0,
        pageSize: 100,
      },
      businessOccurDateRange: [],
      createDateRange: [],
      paymentTimeRange: [],
      businessTypeDialogVisible: false,
      businessTypeLoading: false,
      businessTypeSaving: false,
      newBusinessTypeName: "",
      opreateLogVisible: false,
      opreateLogLoading: false,
      operateHistory: [],
      rejectVisible: false,
      rejectRow: null,
      rejectRemark: "",
      rejectTargetStatus: "",
      rejectSaving: false,
      statusActionSaving: false,
      paymentProofUploadVisible: false,
      paymentProofUploadTitle: "上传支付证明",
      paymentProofUploadUrls: [],
      paymentProofUploadRow: null,
      paymentProofUploadSaving: false,
      paymentProofUploading: false,
      invoiceUploadVisible: false,
      invoiceUploadTitle: "上传发票",
      invoiceUploadRow: null,
      invoiceUploadSaving: false,
      addDialogVisible: false,
      editingReimbursementId: "",
      addSaving: false,
      addForm: createEmptyAddForm(),
      shopOptions: SHOP_OPTIONS,
      invoiceFileItems: [],
      proofUploading: false,
      invoiceUploading: false,
      activeUploadTarget: "proof",
      addRules: {
        shopName: [{ required: true, message: "请选择店铺", trigger: "change" }],
        businessTypeId: [{ required: true, message: "请选择业务类型", trigger: "change" }],
        businessOccurDate: [{ required: true, message: "请选择业务发生日期", trigger: "change" }],
        contentDescription: [{ required: true, message: "请填写报销内容说明", trigger: "blur" }],
        unitPrice: [{ required: true, type: "number", message: "请填写单价", trigger: "blur" }],
        quantity: [{ required: true, type: "number", message: "请填写数量", trigger: "blur" }],
      },
    };
  },
  computed: {
    invoiceImageUrls() {
      return this.invoiceFileItems.filter(item => item.isImage).map(item => item.url);
    },
    businessProofFileItems() {
      return this.getFileItems(this.addForm.businessProofImages);
    },
    businessProofImageUrls() {
      return this.getImageList(this.addForm.businessProofImages);
    },
    addDialogTitle() {
      return this.editingReimbursementId ? "编辑报销" : "新增报销";
    },
  },
  mounted() {
    this.loadBusinessTypes();
    this.loadCreateUsers();
    this.getData();
    this.$nextTick(() => this.calculateHeight());
    this.$eventBus && this.$eventBus.$on && this.$eventBus.$on("resize", this.calculateHeight);
    window.addEventListener("resize", this.calculateHeight);
  },
  beforeDestroy() {
    document.removeEventListener("paste", this.handleAddDialogPaste);
    document.removeEventListener("paste", this.handlePaymentProofPaste);
    document.removeEventListener("paste", this.handleInvoiceUploadPaste);
    window.removeEventListener("resize", this.calculateHeight);
    this.$eventBus && this.$eventBus.$off && this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      const panel = this.$refs.tablePanel;
      if (!panel) {
        return;
      }
      const tabs = panel.querySelector(".status-tabs");
      const pagination = panel.querySelector(".pagination-box");
      const panelStyle = window.getComputedStyle(panel);
      const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
      const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
      const available =
        panel.clientHeight - paddingTop - paddingBottom - (tabs ? tabs.offsetHeight + 12 : 0) - (pagination ? pagination.offsetHeight : 0);
      this.screenHeight = Math.max(available, 200);
    },
    layoutTable() {
      const table = this.$refs.reimbursementTable;
      if (table && table.doLayout) {
        table.doLayout();
      }
    },
    loadBusinessTypes() {
      return reimbursementModules.fetchReimbursementBusinessTypes().then(res => {
        if (res.result !== 1) {
          this.$message.error(res.message || "获取业务类型失败");
          return;
        }
        this.businessTypeList = res.ldata || [];
      });
    },
    loadCreateUsers() {
      return systemModules
        .listUsers()
        .then(res => {
          const users = Array.isArray(res.data) ? res.data : [];
          const seen = new Set();
          this.createUserOptions = users
            .map(user => {
              const name = String((user && (user.nickname || user.username)) || "").trim();
              return {
                id: user && user.id != null ? user.id : name,
                name,
              };
            })
            .filter(user => {
              if (!user.name || seen.has(user.name)) {
                return false;
              }
              seen.add(user.name);
              return true;
            })
            .sort((a, b) => a.name.localeCompare(b.name, "zh"));
        })
        .catch(() => {
          this.createUserOptions = [];
        });
    },
    queryBtn() {
      this.params.beginIndex = 0;
      this.currentPage = 1;
      this.getData();
    },
    onStatusTabChange(tab) {
      this.activeStatusTab = tab.name;
      this.params.beginIndex = 0;
      this.currentPage = 1;
      this.getData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.params.beginIndex = (page - 1) * this.params.pageSize;
      this.getData();
    },
    appendDateRange(params, range, beginKey, endKey) {
      if (!range || range.length !== 2 || !range[0] || !range[1]) {
        return;
      }
      params[beginKey] = range[0];
      params[endKey] = range[1];
    },
    getData() {
      this.loading = true;
      const params = {
        ...this.params,
        statusTab: this.activeStatusTab === "全部" ? "" : this.activeStatusTab,
      };
      this.appendDateRange(params, this.businessOccurDateRange, "beginBusinessOccurDate", "endBusinessOccurDate");
      this.appendDateRange(params, this.createDateRange, "beginCreateDate", "endCreateDate");
      this.appendDateRange(params, this.paymentTimeRange, "beginPaymentTime", "endPaymentTime");
      reimbursementModules
        .fetchReimbursements(params)
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "查询失败");
            return;
          }
          this.tableData = res.ldata || [];
          this.total = res.total || 0;
          const mdata = res.mdata || {};
          this.statusCounts = {
            ...buildEmptyStatusCounts(),
            ...(mdata.statusCounts || {}),
          };
          if (mdata.summary) {
            this.summary = {
              quantity: 0,
              totalPrice: 0,
              taxAmount: 0,
              shippingFee: 0,
              platformDiscount: 0,
              ...mdata.summary,
            };
          } else {
            this.summary = this.sumRows(this.tableData);
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "查询失败");
        })
        .finally(() => {
          this.loading = false;
          this.$nextTick(() => {
            this.calculateHeight();
            this.$nextTick(() => this.layoutTable());
          });
        });
    },
    formatAmount(value) {
      if (value == null || value === "") {
        return "-";
      }
      const num = Number(value);
      if (!Number.isFinite(num)) {
        return "-";
      }
      return num.toFixed(2);
    },
    formatQuantity(value) {
      if (value == null || value === "") {
        return "-";
      }
      const num = Number(value);
      if (!Number.isFinite(num)) {
        return "-";
      }
      return String(num);
    },
    formatTaxRate(value) {
      if (value == null || value === "") {
        return "-";
      }
      const num = Number(value);
      if (!Number.isFinite(num)) {
        return "-";
      }
      return `${(num * 100).toFixed(2)}%`;
    },
    sumRows(rows) {
      return (rows || []).reduce(
        (sum, row) => {
          sum.quantity += Number(row.quantity) || 0;
          sum.totalPrice += Number(row.totalPrice) || 0;
          sum.taxAmount += Number(row.taxAmount) || 0;
          sum.shippingFee += Number(row.shippingFee) || 0;
          sum.platformDiscount += Number(row.platformDiscount) || 0;
          return sum;
        },
        { quantity: 0, totalPrice: 0, taxAmount: 0, shippingFee: 0, platformDiscount: 0 }
      );
    },
    formatCreateTime(value) {
      if (value == null || value === "") {
        return "-";
      }
      const date = new Date(Number(value));
      if (isNaN(date.getTime())) {
        return "-";
      }
      return date.format("yyyy-MM-dd hh:mm");
    },
    getTableSummaries(param) {
      const { columns } = param;
      const summary = this.summary || {};
      const sums = [];
      columns.forEach((column, index) => {
        if (column.label === "序号") {
          sums[index] = "合计";
          return;
        }
        if (column.property === "quantity") {
          const total = Number(summary.quantity);
          sums[index] = Number.isFinite(total) ? String(roundMoney(total)) : "";
          return;
        }
        if (["totalPrice", "taxAmount", "shippingFee", "platformDiscount"].includes(column.property)) {
          sums[index] = this.formatAmount(Number(summary[column.property]) || 0);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    normalizeUrlList(list) {
      if (!list) {
        return [];
      }
      if (Array.isArray(list)) {
        return list.map(item => String(item || "").trim()).filter(Boolean);
      }
      return [];
    },
    isImageUrl(url, name) {
      const source = `${name || ""} ${url || ""}`.toLowerCase();
      return /\.(jpg|jpeg|png|gif|webp|bmp)(\?|$)/i.test(source) || source.indexOf("image/") >= 0;
    },
    getImageList(list) {
      return this.normalizeUrlList(list).filter(url => this.isImageUrl(url));
    },
    getFileItems(list) {
      return this.normalizeUrlList(list).map(url => ({
        url,
        name: "",
        isImage: this.isImageUrl(url),
      }));
    },
    canVoid(row) {
      return row && REIMBURSEMENT_VOIDABLE_STATUSES.indexOf(row.status) >= 0;
    },
    canReject(row) {
      return row && REIMBURSEMENT_REJECTABLE_STATUSES.indexOf(row.status) >= 0;
    },
    canEdit(row) {
      return row && REIMBURSEMENT_EDITABLE_STATUSES.indexOf(row.status) >= 0;
    },
    canUploadPaymentProof(row) {
      return row && row.status === REIMBURSEMENT_STATUS.PENDING_PAYMENT;
    },
    canUploadInvoice(row) {
      return row && row.status === REIMBURSEMENT_STATUS.PENDING_FINANCE_AUDIT;
    },
    getInvoiceButtonLabel(row) {
      return this.getFileItems(row && row.invoiceFiles).length ? "编辑发票" : "上传发票";
    },
    getPaymentProofButtonLabel(row) {
      return this.getImageList(row && row.paymentProofImages).length ? "编辑支付证明" : "上传支付证明";
    },
    openPaymentProofUpload(row) {
      if (!row || !row.reimbursementId) {
        return;
      }
      this.paymentProofUploadRow = row;
      this.paymentProofUploadUrls = [...this.getImageList(row.paymentProofImages)];
      this.paymentProofUploadTitle = this.getPaymentProofButtonLabel(row);
      this.paymentProofUploadVisible = true;
    },
    onPaymentProofUploadOpened() {
      document.addEventListener("paste", this.handlePaymentProofPaste);
      this.$nextTick(() => {
        if (this.$refs.paymentProofPastePanel) {
          this.$refs.paymentProofPastePanel.focus();
        }
      });
    },
    onPaymentProofUploadClosed() {
      document.removeEventListener("paste", this.handlePaymentProofPaste);
      this.paymentProofUploading = false;
      this.paymentProofUploadRow = null;
    },
    beforePaymentProofUpload(file) {
      if (!this.isImageFile(file)) {
        this.$message.error("支付证明仅支持图片");
        return false;
      }
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过 20MB");
        return false;
      }
      return true;
    },
    handlePaymentProofUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        this.paymentProofUploadUrls.push(res.objData.fileUrl);
        return;
      }
      this.$message.error((res && res.message) || "上传失败");
    },
    handlePaymentProofUploadError() {
      this.$message.error("支付证明上传失败");
    },
    handlePaymentProofPaste(event) {
      if (!this.paymentProofUploadVisible || this.paymentProofUploading) {
        return;
      }
      const items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          const file = item.getAsFile();
          if (file) {
            this.uploadPastedPaymentProof(file);
          }
          return;
        }
      }
    },
    uploadPastedPaymentProof(file) {
      if (!this.isImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "reimbursementMgmt");
      this.paymentProofUploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.paymentProofUploadUrls.push(res.objData.fileUrl);
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.paymentProofUploading = false;
        });
    },
    savePaymentProofUpload() {
      if (!this.paymentProofUploadRow || !this.paymentProofUploadRow.reimbursementId) {
        return;
      }
      if (!this.paymentProofUploadUrls.length) {
        this.$message.error("请至少上传一张支付证明");
        return;
      }
      this.paymentProofUploadSaving = true;
      reimbursementModules
        .updateReimbursementAttachment({
          reimbursementId: this.paymentProofUploadRow.reimbursementId,
          paymentProofImages: JSON.stringify(this.paymentProofUploadUrls),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "保存失败");
            return;
          }
          this.$message.success("支付证明已保存");
          this.paymentProofUploadVisible = false;
          this.getData();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "保存失败");
        })
        .finally(() => {
          this.paymentProofUploadSaving = false;
        });
    },
    openInvoiceUpload(row) {
      if (!row || !row.reimbursementId) {
        return;
      }
      this.invoiceUploadRow = row;
      this.invoiceFileItems = this.getFileItems(row.invoiceFiles);
      this.invoiceUploadTitle = this.getInvoiceButtonLabel(row);
      this.invoiceUploadVisible = true;
    },
    onInvoiceUploadOpened() {
      document.addEventListener("paste", this.handleInvoiceUploadPaste);
      this.$nextTick(() => {
        if (this.$refs.invoiceUploadPastePanel) {
          this.$refs.invoiceUploadPastePanel.focus();
        }
      });
    },
    onInvoiceUploadClosed() {
      document.removeEventListener("paste", this.handleInvoiceUploadPaste);
      this.invoiceUploading = false;
      this.invoiceUploadRow = null;
    },
    handleInvoiceUploadPaste(event) {
      if (!this.invoiceUploadVisible || this.invoiceUploading) {
        return;
      }
      const items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          const file = item.getAsFile();
          if (file) {
            this.uploadPastedInvoiceImage(file);
          }
          return;
        }
      }
    },
    saveInvoiceUpload() {
      if (!this.invoiceUploadRow || !this.invoiceUploadRow.reimbursementId) {
        return;
      }
      if (this.invoiceUploading) {
        this.$message.warning("文件上传中，请稍后");
        return;
      }
      if (!this.invoiceFileItems.length) {
        this.$message.error("请至少上传一份发票");
        return;
      }
      this.invoiceUploadSaving = true;
      reimbursementModules
        .updateReimbursementAttachment({
          reimbursementId: this.invoiceUploadRow.reimbursementId,
          invoiceFiles: JSON.stringify(this.invoiceFileItems.map(item => item.url)),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "保存失败");
            return;
          }
          this.$message.success("发票已保存");
          this.invoiceUploadVisible = false;
          this.getData();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "保存失败");
        })
        .finally(() => {
          this.invoiceUploadSaving = false;
        });
    },
    getPrimaryAction(row) {
      if (!row || !row.status) {
        return null;
      }
      return REIMBURSEMENT_PRIMARY_ACTION[row.status] || null;
    },
    getMoreActions(row) {
      const actions = [];
      if (this.canEdit(row)) {
        actions.push({ key: "edit", label: "编辑" });
      }
      if (this.canReject(row)) {
        actions.push({ key: "reject", label: "打回", btnClass: "warning" });
      }
      if (this.canVoid(row)) {
        actions.push({ key: "void", label: "作废", btnClass: "danger" });
      }
      actions.push({ key: "log", label: "操作记录" });
      return actions;
    },
    handleMoreAction(command, row) {
      if (command === "edit") {
        this.openEditDialog(row);
        return;
      }
      if (command === "reject") {
        this.openRejectDialog(row);
        return;
      }
      if (command === "void") {
        this.voidReimbursement(row);
        return;
      }
      if (command === "log") {
        this.showOpreateLog(row);
      }
    },
    updateStatus(row, action, extraPayload) {
      if (!row || !row.reimbursementId) {
        this.$message.warning("缺少报销单号");
        return Promise.resolve();
      }
      if (this.statusActionSaving) {
        return Promise.resolve();
      }
      this.statusActionSaving = true;
      return reimbursementModules
        .updateReimbursementStatus({
          reimbursementId: row.reimbursementId,
          action,
          ...(extraPayload || {}),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "操作失败");
            return;
          }
          this.$message.success("操作成功");
          this.getData();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "操作失败");
        })
        .finally(() => {
          this.statusActionSaving = false;
        });
    },
    onPrimaryAction(row) {
      const primary = this.getPrimaryAction(row);
      if (!primary) {
        return;
      }
      if (
        primary.action === "approve" &&
        row.status === REIMBURSEMENT_STATUS.PENDING_PAYMENT &&
        !this.getImageList(row.paymentProofImages).length
      ) {
        this.$message.warning("请先上传支付证明");
        this.openPaymentProofUpload(row);
        return;
      }
      this.$confirm(`确认「${primary.label}」？`, primary.label, {
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        this.updateStatus(row, primary.action);
      });
    },
    openRejectDialog(row) {
      this.rejectRow = row;
      this.rejectRemark = "";
      this.rejectTargetStatus = (row && REIMBURSEMENT_ACTION_REJECT[row.status]) || "";
      this.rejectVisible = true;
    },
    confirmReject() {
      if (!(this.rejectRemark || "").trim()) {
        this.$message.warning("请填写打回原因");
        return;
      }
      if (!this.rejectRow || !this.rejectRow.reimbursementId) {
        return;
      }
      this.rejectSaving = true;
      reimbursementModules
        .updateReimbursementStatus({
          reimbursementId: this.rejectRow.reimbursementId,
          action: "reject",
          rejectRemark: (this.rejectRemark || "").trim(),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "打回失败");
            return;
          }
          this.$message.success("已打回");
          this.rejectVisible = false;
          this.rejectRow = null;
          this.rejectRemark = "";
          this.getData();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "打回失败");
        })
        .finally(() => {
          this.rejectSaving = false;
        });
    },
    voidReimbursement(row) {
      if (!row || !row.reimbursementId) {
        this.$message.warning("缺少报销单号");
        return;
      }
      this.$confirm("确认作废该报销单？作废后不可继续审批。", "作废", {
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        this.updateStatus(row, "void");
      });
    },
    showOpreateLog(row) {
      if (!row || !row.reimbursementId) {
        this.$message.warning("缺少报销单号");
        return;
      }
      this.operateHistory = [];
      this.opreateLogVisible = true;
      this.opreateLogLoading = true;
      requestModules
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId: row.reimbursementId,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取操作记录失败");
            return;
          }
          this.operateHistory = res.ldata || [];
          if (!this.operateHistory.length) {
            this.$message.info("暂无操作记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        })
        .finally(() => {
          this.opreateLogLoading = false;
        });
    },
    openBusinessTypeDialog() {
      this.businessTypeDialogVisible = true;
      this.newBusinessTypeName = "";
      this.reloadBusinessTypesInDialog();
    },
    reloadBusinessTypesInDialog() {
      this.businessTypeLoading = true;
      this.loadBusinessTypes().finally(() => {
        this.businessTypeLoading = false;
      });
    },
    addBusinessType() {
      const name = (this.newBusinessTypeName || "").trim();
      if (!name) {
        this.$message.warning("请输入业务类型名称");
        return;
      }
      this.businessTypeSaving = true;
      reimbursementModules
        .addOrUpdateReimbursementBusinessType({ name })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "新增失败");
            return;
          }
          this.$message.success("新增成功");
          this.newBusinessTypeName = "";
          this.reloadBusinessTypesInDialog();
        })
        .finally(() => {
          this.businessTypeSaving = false;
        });
    },
    deleteBusinessType(row) {
      if (!row || !row._id) {
        return;
      }
      this.$confirm(`确认删除业务类型「${row.name}」？`, "删除", {
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        reimbursementModules.deleteReimbursementBusinessType({ _id: row._id, businessTypeId: row.businessTypeId }).then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "删除失败");
            return;
          }
          this.$message.success("删除成功");
          if (this.params.businessTypeId === row.businessTypeId) {
            this.params.businessTypeId = "";
          }
          this.reloadBusinessTypesInDialog();
        });
      });
    },
    openAddDialog() {
      if (!this.businessTypeList.length) {
        this.loadBusinessTypes().then(() => {
          if (!this.businessTypeList.length) {
            this.$message.warning("请先维护业务类型");
            this.openBusinessTypeDialog();
            return;
          }
          this.resetAddForm();
          this.addDialogVisible = true;
        });
        return;
      }
      this.resetAddForm();
      this.addDialogVisible = true;
    },
    openEditDialog(row) {
      if (!row || !row.reimbursementId) {
        return;
      }
      const open = () => {
        this.addForm = {
          shopName: row.shopName || "",
          businessTypeId: row.businessTypeId || "",
          businessOccurDate: row.businessOccurDate || "",
          contentDescription: row.contentDescription || "",
          unitPrice: Number(row.unitPrice) || 0,
          quantity: Number(row.quantity) || 1,
          totalPrice: Number(row.totalPrice) || 0,
          taxRatePercent: roundMoney((Number(row.taxRate) || 0) * 100),
          taxAmount: Number(row.taxAmount) || 0,
          shippingFee: Number(row.shippingFee) || 0,
          platformDiscount: Number(row.platformDiscount) || 0,
          businessProofImages: this.normalizeUrlList(row.businessProofImages),
          remark: row.remark || "",
        };
        this.invoiceFileItems = this.getFileItems(row.invoiceFiles);
        this.editingReimbursementId = row.reimbursementId;
        this.activeUploadTarget = "proof";
        this.recalcAmounts();
        this.addDialogVisible = true;
        this.$nextTick(() => {
          if (this.$refs.addForm) {
            this.$refs.addForm.clearValidate();
          }
        });
      };
      if (!this.businessTypeList.length) {
        this.loadBusinessTypes().then(open);
        return;
      }
      open();
    },
    resetAddForm() {
      this.editingReimbursementId = "";
      this.addForm = createEmptyAddForm();
      this.invoiceFileItems = [];
      this.activeUploadTarget = "proof";
      this.recalcAmounts();
      this.$nextTick(() => {
        if (this.$refs.addForm) {
          this.$refs.addForm.clearValidate();
        }
      });
    },
    recalcAmounts() {
      const unitPrice = Number(this.addForm.unitPrice) || 0;
      const quantity = Number(this.addForm.quantity) || 0;
      const taxRate = (Number(this.addForm.taxRatePercent) || 0) / 100;
      this.addForm.totalPrice = roundMoney(unitPrice * quantity);
      this.addForm.taxAmount = roundMoney(this.addForm.totalPrice * taxRate);
    },
    setActiveUploadTarget(target) {
      this.activeUploadTarget = target;
    },
    onAddDialogOpened() {
      document.addEventListener("paste", this.handleAddDialogPaste);
      this.$nextTick(() => {
        if (this.$refs.proofPastePanel) {
          this.$refs.proofPastePanel.focus();
        }
      });
    },
    onAddDialogClosed() {
      document.removeEventListener("paste", this.handleAddDialogPaste);
      this.proofUploading = false;
      this.invoiceUploading = false;
    },
    isImageFile(file) {
      if (!file) {
        return false;
      }
      if (file.type && file.type.indexOf("image/") === 0) {
        return true;
      }
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(file.name || "");
    },
    isPdfFile(file) {
      if (!file) {
        return false;
      }
      return (file.type && file.type === "application/pdf") || /\.pdf$/i.test(file.name || "");
    },
    beforeProofFileUpload(file) {
      if (!this.isImageFile(file) && !this.isPdfFile(file)) {
        this.$message.error("业务证明仅支持图片或 PDF");
        return false;
      }
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过 20MB");
        return false;
      }
      return true;
    },
    beforeInvoiceFileUpload(file) {
      if (!this.isImageFile(file) && !this.isPdfFile(file)) {
        this.$message.error("发票仅支持图片或 PDF");
        return false;
      }
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过 20MB");
        return false;
      }
      return true;
    },
    handleProofUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        this.addForm.businessProofImages.push(res.objData.fileUrl);
        return;
      }
      this.$message.error((res && res.message) || "上传失败");
    },
    handleProofUploadError() {
      this.$message.error("业务证明上传失败");
    },
    removeProofFile(index) {
      this.addForm.businessProofImages.splice(index, 1);
    },
    handleInvoiceUploadSuccess(res) {
      if (res && res.objData && res.objData.fileUrl) {
        const url = res.objData.fileUrl;
        const name = res.objData.originalFileName || "";
        this.invoiceFileItems.push({
          url,
          name,
          isImage: this.isImageUrl(url, name),
        });
        return;
      }
      this.$message.error((res && res.message) || "上传失败");
    },
    handleInvoiceUploadError() {
      this.$message.error("发票上传失败");
    },
    removeInvoiceFile(index) {
      this.invoiceFileItems.splice(index, 1);
    },
    handleAddDialogPaste(event) {
      if (!this.addDialogVisible) {
        return;
      }
      if (this.proofUploading || this.invoiceUploading) {
        return;
      }
      const items = event.clipboardData && event.clipboardData.items;
      if (!items || !items.length) {
        return;
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && item.type.indexOf("image/") === 0) {
          event.preventDefault();
          const file = item.getAsFile();
          if (!file) {
            return;
          }
          if (this.activeUploadTarget === "invoice") {
            this.uploadPastedInvoiceImage(file);
          } else {
            this.uploadPastedProofImage(file);
          }
          return;
        }
      }
    },
    uploadPastedProofImage(file) {
      if (!this.isImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "reimbursementMgmt");
      this.proofUploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.addForm.businessProofImages.push(res.objData.fileUrl);
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.proofUploading = false;
        });
    },
    uploadPastedInvoiceImage(file) {
      if (!this.isImageFile(file)) {
        this.$message.error("请粘贴图片文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bizModule", "reimbursementMgmt");
      this.invoiceUploading = true;
      ossModules
        .upload(formData)
        .then(res => {
          if (res && res.objData && res.objData.fileUrl) {
            this.invoiceFileItems.push({
              url: res.objData.fileUrl,
              name: res.objData.originalFileName || file.name || "",
              isImage: true,
            });
            return;
          }
          this.$message.error((res && res.message) || "上传失败");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "上传失败");
        })
        .finally(() => {
          this.invoiceUploading = false;
        });
    },
    submitAdd() {
      this.$refs.addForm.validate(valid => {
        if (!valid) {
          return;
        }
        if (this.proofUploading || this.invoiceUploading) {
          this.$message.warning("文件上传中，请稍后");
          return;
        }
        this.recalcAmounts();
        const unitPrice = Number(this.addForm.unitPrice);
        const quantity = Number(this.addForm.quantity);
        if (!(unitPrice >= 0)) {
          this.$message.error("请填写有效单价");
          return;
        }
        if (!(quantity > 0)) {
          this.$message.error("数量必须大于 0");
          return;
        }
        const taxRate = roundMoney((Number(this.addForm.taxRatePercent) || 0) / 100);
        const payload = {
          shopName: this.addForm.shopName,
          businessTypeId: this.addForm.businessTypeId,
          businessOccurDate: this.addForm.businessOccurDate || "",
          contentDescription: (this.addForm.contentDescription || "").trim(),
          unitPrice: roundMoney(unitPrice),
          quantity,
          taxRate,
          shippingFee: roundMoney(this.addForm.shippingFee || 0),
          platformDiscount: roundMoney(this.addForm.platformDiscount || 0),
          businessProofImages: JSON.stringify(this.addForm.businessProofImages || []),
          invoiceFiles: JSON.stringify(this.invoiceFileItems.map(item => item.url)),
          remark: (this.addForm.remark || "").trim(),
        };
        const isEdit = !!this.editingReimbursementId;
        if (isEdit) {
          payload.reimbursementId = this.editingReimbursementId;
        }
        this.addSaving = true;
        reimbursementModules
          .addOrUpdateReimbursement(payload)
          .then(res => {
            if (res.result !== 1) {
              this.$message.error(res.message || "保存失败");
              return;
            }
            this.$message.success(isEdit ? "保存成功" : "新增成功");
            this.addDialogVisible = false;
            if (!isEdit) {
              this.activeStatusTab = "待确认";
              this.params.beginIndex = 0;
              this.currentPage = 1;
            }
            this.getData();
          })
          .catch(err => {
            this.$message.error((err && err.message) || "保存失败");
          })
          .finally(() => {
            this.addSaving = false;
          });
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#ReimbursementMgmt {
  .filter-payment-time {
    width: 320px !important;
  }

  .reimbursement-table {
    .el-table__footer-wrapper td,
    .el-table__fixed-footer-wrapper td {
      background: #fafafa !important;
      font-weight: 600;
      color: #303133;
      font-size: 12px;
    }

    .el-table__footer-wrapper td .cell,
    .el-table__fixed-footer-wrapper td .cell {
      padding: 0 4px;
      line-height: 23px;
      white-space: nowrap;
    }

    /* 固定列合计与主表合计行对齐，避免「合计」格上下偏移 */
    .el-table__fixed,
    .el-table__fixed-right {
      height: 100% !important;
      bottom: 0 !important;
    }

    .el-table__fixed .el-table__fixed-footer-wrapper,
    .el-table__fixed-right .el-table__fixed-footer-wrapper {
      position: absolute;
      bottom: 0;
      z-index: 4;
    }

    .el-table__fixed .el-table__fixed-footer-wrapper {
      left: 0;
      right: auto;
    }

    .el-table__fixed-right .el-table__fixed-footer-wrapper {
      left: auto;
      right: 0;
    }
  }

  .reject-remark {
    margin-top: 4px;
    color: #e6a23c;
    font-size: 12px;
  }

  .reject-dialog-tip {
    margin-bottom: 12px;
    color: #606266;
    font-size: 13px;
  }

  .action-cell-nowrap {
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .action-cell .danger {
    color: #f56c6c;
  }

  .action-cell .warning {
    color: #e6a23c;
  }

  .action-cell .success {
    color: #67c23a;
  }

  .proof-empty {
    color: #c0c4cc;
  }

  .proof-thumb-list {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
    padding: 2px 0;
  }

  .proof-thumb {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    vertical-align: middle;
  }

  .invoice-pdf-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    color: #409eff;
    font-size: 20px;
    text-decoration: none;
  }

  .business-type-toolbar {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
  }

  .business-type-input {
    flex: 1;
  }
}

.reimbursement-action-dropdown {
  .el-dropdown-menu__item.warning {
    color: #e6a23c;
  }

  .el-dropdown-menu__item.danger {
    color: #f56c6c;
  }
}

.reimbursement-payment-time-popper {
  .el-time-spinner__wrapper:nth-child(2),
  .el-time-spinner__wrapper:nth-child(3) {
    display: none;
  }

  .el-time-spinner__wrapper {
    width: 100%;
  }
}

.reimbursement-add-dialog,
.reimbursement-payment-proof-dialog,
.reimbursement-invoice-upload-dialog {
  .proof-upload-panel {
    outline: none;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    padding: 10px;
    background: #fafafa;
  }

  .proof-upload-panel.is-active {
    border-color: #409eff;
    background: #f5f9ff;
  }

  .proof-upload-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .proof-upload-item {
    position: relative;
    width: 88px;
    height: 88px;
  }

  .proof-upload-image {
    width: 88px;
    height: 88px;
    border-radius: 4px;
  }

  .proof-upload-pdf {
    width: 88px;
    height: 88px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    box-sizing: border-box;
    text-align: center;
    font-size: 12px;
    word-break: break-all;
  }

  .proof-upload-remove {
    position: absolute;
    top: -6px;
    right: -6px;
    color: #f56c6c;
    font-size: 16px;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
  }

  .proof-upload-add {
    width: 88px;
    height: 88px;
  }

  .proof-upload-trigger {
    width: 88px;
    height: 88px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
    background: #fff;
    cursor: pointer;
  }

  .proof-upload-text {
    margin-top: 4px;
    font-size: 12px;
  }

  .proof-upload-tip {
    margin-top: 8px;
    color: #909399;
    font-size: 12px;
  }
}
</style>
